<template>
  <div class="joinUs">
    <el-container>
      <el-main style="margin:0px;padding:0px;" >
        <el-row style="margin:0px;padding:0px;">
          <span style="font-size: 22px;">合作领域</span>
        </el-row>
        <el-row>
          <el-col :span="2">
            <img width="60px" height="60px" src="@/assets/image/event_point.png">
          </el-col>
          <el-col :span="22"  style="margin-top:12px;">
            <span style="font-size: 20px;">精通社区业务拓展及服务理念的合作伙伴，具有5年以上社区工作经验（1名）。</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <img width="60px" height="60px" src="@/assets/image/event_point.png">
          </el-col>
          <el-col :span="22"  style="margin-top:12px;">
            <span style="font-size: 20px;">具有环保领域业务拓展及人际关系的合作伙伴（1名）。</span>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="2">
            <img width="60px" height="60px" src="@/assets/image/event_point.png">
          </el-col>
          <el-col :span="22"  style="margin-top:12px;">
            <span style="font-size: 20px;">具有产品生产商渠道及产品分销、门店推广、产品防伪经验的合作伙伴（1名）。</span>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
  </div>
</template>

<script>
export default {
  name: 'seedTracePage'
}
</script>

<style lang="less" scoped>
body {
  margin: 0px;
}
.joinUs {
  margin-left: 20px;
  padding-left: 20px;
  height: 500px;
}
.el-row {
  margin-top: 10px;
  padding-top: 10px;
  text-align: left;
}
</style>
